import { useMutation } from '@tanstack/react-query'
import { startAssessmentsCall } from 'api/admin/coach/startAssessmentsCall'

export const useStartAssessmentsCall = () => {
  return useMutation({
    mutationFn: startAssessmentsCall,
  })
}
